import { type PropsWithChildren, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import colors, { withOpacity } from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

const StickyButtonMargin = styled.div<{
  $contentHeight: number;
}>`
  margin-top: ${({ $contentHeight }) => `${toRem($contentHeight + 5)}`};
`;

const StickyBottomContainer = styled.div<{
  $isFixed: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: ${({ $isFixed }) => ($isFixed ? 'fixed' : 'sticky')};
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 ${toRem(2)} ${toRem(20)} ${withOpacity(colors.neutral100, 0.1)};
  border-radius: ${toRem(30)} ${toRem(30)} 0 0;
  box-sizing: border-box;
  background-color: ${colors.white100};
`;

export type StickyBottomWrapperProps = PropsWithChildren<{
  isFixed?: boolean;
  className?: string;
}>;

const StickyBottomWrapper = ({ className, isFixed = false, children }: StickyBottomWrapperProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    setContentHeight(ref.current?.getBoundingClientRect().height || 0);
  }, []);

  return (
    <>
      {/* A fixed bar leaves the page flow, so this keeps it from hiding the end of the content */}
      {isFixed && <StickyButtonMargin $contentHeight={contentHeight} />}
      <StickyBottomContainer className={className} $isFixed={isFixed} ref={ref} data-testid='sticky-bottom-wrapper'>
        {children}
      </StickyBottomContainer>
    </>
  );
};

export default StickyBottomWrapper;
